export default __webpack_public_path__ + "static/media/EggplantParmSub.387fd9e8.jpg";